module.exports = __webpack_public_path__ + "img/result.b84f2b3b.png";